const success = {
    saved: '保存しました',
    uploaded: 'アップロードしました',
    deleted: '削除しました',
    updated: '更新しました',
    shared: '共有しました',
  };

export default success;
